import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

let echoInstance = null

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL
const referralWsKey = process.env.VUE_APP_REFERRAl_WS_KEY

const domainApiUrl = new URL(referralApiUrl)?.hostname

export const initEcho = (token) => {
  if (echoInstance) {
    return echoInstance
  }

  echoInstance = new Echo({
    broadcaster: 'reverb',
    key: referralWsKey,
    wsHost: domainApiUrl,
    wsPort: 443,
    wssPort: 443,
    wsPath: '/ws',
    forceTLS: false,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `https://${domainApiUrl}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    },
    withCredentials: true,
  })

  return echoInstance
}

export const getEcho = () => echoInstance

export const destroyEcho = () => {
  if (!echoInstance) {
    return
  }

  echoInstance.disconnect()

  echoInstance = null
}
